
import { Link } from 'react-router-dom';

export default function ExperienceCategories() {
  const categories = [
    {
      id: 1,
      title: 'Mountain Retreats',
      description: 'Elevated glamping experiences with panoramic mountain views and alpine adventures.',
      image: 'https://public.readdy.ai/ai/img_res/0b30e670985503d55a24ff0a01426ba3.jpg',
      icon: 'ri-mountain-line',
      experiences: 12,
      route: '/experiences/mountain'
    },
    {
      id: 2,
      title: 'Forest Sanctuaries',
      description: 'Immersive woodland experiences surrounded by ancient trees and wildlife.',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20safari%20tent%20in%20dense%20forest%20clearing%20surrounded%20by%20towering%20old-growth%20trees%2C%20dappled%20sunlight%20filtering%20through%20canopy%2C%20wooden%20walkway%20leading%20to%20tent%2C%20peaceful%20woodland%20setting%2C%20luxury%20eco-accommodation%20with%20natural%20materials%20and%20forest%20integration&width=400&height=300&seq=forest-sanctuary-001&orientation=landscape',
      icon: 'ri-tree-line',
      experiences: 8,
      route: '/experiences/forest'
    },
    {
      id: 3,
      title: 'Lakeside Escapes',
      description: 'Waterfront glamping with pristine lake views and aquatic adventures.',
      image: 'https://readdy.ai/api/search-image?query=Premium%20glamping%20tent%20positioned%20on%20lakeside%20with%20crystal%20clear%20water%20reflecting%20mountains%2C%20wooden%20dock%20extending%20into%20lake%2C%20canoe%20and%20kayaks%20nearby%2C%20serene%20morning%20mist%20over%20water%2C%20luxury%20waterfront%20accommodation%20with%20panoramic%20lake%20views&width=400&height=300&seq=lakeside-escape-001&orientation=landscape',
      icon: 'ri-water-line',
      experiences: 6,
      route: '/experiences/lakeside'
    },
    {
      id: 4,
      title: 'Desert Oasis',
      description: 'Unique desert glamping under starlit skies with luxury amenities.',
      image: 'https://readdy.ai/api/search-image?query=Luxury%20desert%20glamping%20tent%20in%20vast%20desert%20landscape%20with%20red%20rock%20formations%2C%20clear%20starry%20night%20sky%2C%20warm%20ambient%20lighting%20from%20tent%2C%20cacti%20and%20desert%20plants%2C%20premium%20desert%20accommodation%20with%20modern%20comforts%20in%20remote%20natural%20setting&width=400&height=300&seq=desert-oasis-001&orientation=landscape',
      icon: 'ri-sun-line',
      experiences: 4,
      route: '/experiences/desert'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Discover Your Perfect
            <span className="text-emerald-600"> Glamping Experience</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From mountain peaks to forest sanctuaries, explore our curated collection of luxury outdoor accommodations designed for the discerning adventurer.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {categories.map((category) => (
            <div key={category.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 group cursor-pointer">
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={category.image} 
                  alt={category.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-4 left-4 w-12 h-12 bg-white/90 rounded-full flex items-center justify-center">
                  <i className={`${category.icon} text-emerald-600 text-xl`}></i>
                </div>
                <div className="absolute top-4 right-4 bg-emerald-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                  {category.experiences} Sites
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">{category.title}</h3>
                <p className="text-gray-600 mb-4 leading-relaxed">{category.description}</p>
                <Link 
                  to={category.route}
                  className="inline-flex items-center text-emerald-600 font-semibold hover:text-emerald-700 transition-colors cursor-pointer"
                >
                  Explore Category
                  <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
